import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export function NotFound() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        textAlign: 'center',
        py: 10,
        px: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Typography variant="h2" sx={{ fontWeight: 700, mb: 2 }}>
        404
      </Typography>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Page Not Found
      </Typography>
      <Typography variant="body1" sx={{ mb: 4, maxWidth: 500 }}>
        Sorry, we couldn’t find the page you were looking for. It might have been removed or you may have mistyped the URL.
      </Typography>
      <Button
        variant="contained"
        onClick={() => navigate('/')}
        sx={{ textTransform: 'none', fontWeight: 500 }}
      >
        Go back home
      </Button>
    </Box>
  );
}
